export default "__VITE_ASSET__ubauP13c__"